import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recordActivity } from '../features/inactivity/inactivitySlice';
import useLogout from '../hooks/useLogout';

const COUNTDOWN_START = 10;

const InactivityWarningModal = () => {
  const dispatch        = useDispatch();
  const handleLogout    = useLogout();
  const warningVisible  = useSelector((state) => state.inactivity.warningVisible);
  const [countdown, setCountdown] = useState(COUNTDOWN_START);

  useEffect(() => {
    if (!warningVisible) {
      setCountdown(COUNTDOWN_START);
      return;
    }

    setCountdown(COUNTDOWN_START);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [warningVisible, handleLogout]);

  if (!warningVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-surface border border-border rounded-xl shadow-lg p-6 w-full max-w-sm mx-4 flex flex-col items-center gap-4">

        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-warning/10">
          <span className="text-warning text-2xl font-bold">!</span>
        </div>

        <h2 className="text-section font-semibold text-ink text-center">
          Still there?
        </h2>

        <p className="text-body text-ink-2 text-center">
          You've been inactive. You'll be logged out automatically in:
        </p>

        <span className="text-kpi font-mono text-critical">
          {countdown}s
        </span>

        <button
          onClick={() => dispatch(recordActivity())}
          className="w-full bg-ink text-white rounded-lg text-label font-medium px-4 py-2 hover:bg-ink-2 transition"
        >
          I'm still here
        </button>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
